import React, { Component, Fragment } from 'react'
import axios, { getAccessToken, getParticipantInfo } from '../Shared/axios'
import { Helmet } from 'react-helmet'
import Loading from '../Shared/Loading'
import { Icon, Alert } from 'loyal-react'
import ParticipantModal from './ParticipantModal'
import PropTypes from 'prop-types'
import './ParticipantDistributionPoint.css'
import {
  validNameInput,
  validEmailInput,
  validChangeName,
  validLoginInput,
  validNumber,
  requestGetApi
} from '../Shared/utils'
import CsvModalError from './CsvModalError'
import CsvModal from './CsvModal'
import 'whatwg-fetch'
import { formatNumber } from '../../LikePlusCustom/Helpers'
const buttonRef = React.createRef()

class ParticipantDistributionPoint extends Component {
  constructor (props) {
    super(props)
    this.state = {
      branchId: this.props.history.location.state ? this.props.history.location.state.branchId : null,
      branchName: this.props.history.location.state ? this.props.history.location.state.branchName : '',
      creditName: this.props.history.location.state ? this.props.history.location.state.creditName : '',
      participant: {
        name: '',
        email: '',
        login: '',
        value: 0
      },
      walletBalance: 0,
      availableBalance: 0,
      isValidName: false,
      isValidEmail: false,
      isValidLogin: false,
      isValidPoints: false,
      disableFields: false,
      participants: [],
      loading: false,
      participantModal: false,
      csvModal: false,
      csvModalError: false,
      successMessage: false,
      errorMessage: false,
      csvErrors: [],
      loginType: 'CPF',
      totalPoints: 0,
      alertMessage: ''
    }

    if (!this.props.history.location.state) this.props.history.push('/branch-details')
  }

  async componentDidMount () {
    await this.getWalletBalance()
  }

  async getWalletBalance () {
    if (!this.state.branchId) return

    this.updateState('loading', true)
    const response = await requestGetApi(`wallet/balance?branchId=${this.state.branchId}&creditName=${this.state.creditName}`)

    this.updateState('walletBalance', response.balance)
    this.updateState('availableBalance', response.balance)
    this.updateState('loading', false)
  }

  async getParticipantByLogin (login) {
    this.updateState('loading', true)

    const participant = getParticipantInfo()

    const headers = {
      'Authorization': `Bearer ${getAccessToken()}`,
      'campaignId': `${participant['custom:campaign_id']}`,
      'catalogId': `${participant['custom:catalog_id']}`
    }

    await axios
      .get(`participant/${login}`, { headers })
      .then((res) => {
        let data = res.data
        if (data) {
          let { email, name } = data
          let participant = this.state.participant
          participant.name = name
          participant.email = email
          this.updateState('participant', participant)
          this.updateState('isValidName', true)
          this.updateState('isValidEmail', true)
          this.updateState('disableFields', true)
        } else {
          this.updateState('disableFields', false)
        }
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        this.updateState('loading', false)
      })
  }

  navigate () {
    this.props.history.push('/')
  }

  async addParticipant () {
    let participant = this.state.participant
    let availableBalance = this.state.availableBalance
    let participantArray = this.state.participants

    if (participant.value <= availableBalance) {
      availableBalance -= participant.value
      this.updateState('isValidPoints', true)
    } else {
      this.updateState('isValidPoints', false)
      return
    }

    this.updateState('availableBalance', availableBalance)
    this.toggleModal('participantModal')
    this.updateState('loading', true)

    participantArray.push(participant)
    this.updateState('participants', participantArray)
    this.updateState('participant', {
      name: '',
      email: '',
      login: '',
      value: 0
    })
    this.updateState('loading', false)
  }

  removeParticipant (index) {
    let participantArray = this.state.participants
    let participant = participantArray[index]
    let availableBalance = this.state.availableBalance
    availableBalance += participant.value
    participantArray.splice(index, 1)
    this.updateState('participants', participantArray)
    this.updateState('availableBalance', availableBalance)
  }

  correctlyPoints () {
    let participants = this.state.participants
    let totalPoints = 0
    let walletBalance = this.state.walletBalance
    for (const participant of participants) {
      totalPoints += parseFloat(participant.value)
    }
    return totalPoints === walletBalance
  }

  downloadModelo () {
    // eslint-disable-next-line no-undef
    fetch('https://premmiardev.blob.core.windows.net/files/modelo_participantes.csv')
      .then(response => {
        response.blob().then(blob => {
          let url = window.URL.createObjectURL(blob)
          let a = document.createElement('a')
          a.href = url
          a.download = 'modelo_pre_cadastro.csv'
          a.click()
        })
      })
  }

  emailCsvValidation (email) {
    const validator = /^[^\s@]+@[^\s@]+[.]+[^\s@]+$/
    return validator.test(email)
  }

  uploadCallback (data) {
    this.updateState('csvModal', false)
    this.updateState('participants', [])
    this.updateState('totalPoints', 0)
    let csvErrors = []
    let totalValue = this.state.totalPoints
    let availableBalance = this.state.availableBalance

    for (let i = 0; i < data.length; i++) {
      if (parseFloat(data[i].value) < 0) {
        csvErrors.push({ line: i + 2, type: 'valor', value: data[i].value })
      } else {
        totalValue += parseFloat(data[i].value)
      }
      if (data[i].name.split(' ').length <= 1) {
        csvErrors.push({ line: i + 2, type: 'nome', value: data[i].name })
      }
      if (!this.emailCsvValidation(data[i].email)) {
        csvErrors.push({ line: i + 2, type: 'email', value: data[i].email })
      }
      if (this.state.loginType === 'CPF') {
        data[i].login = (data[i].login.toString()).padStart(11, '0')
      }
      // if (this.state.loginType === 'CPF') {
      //   data[i].login = data[i].login.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4')
      // }
    }

    if (totalValue > availableBalance) {
      csvErrors.push({ totalPoints: totalValue })
    }

    if (csvErrors.length === 0) {
      this.updateState('participants', data)
    } else {
      this.updateState('csvErrors', csvErrors)
    }

    this.updateState('totalPoints', totalValue)
  }

  sendPoints () {
    const participants = this.state.participants
    const walletBalance = this.state.walletBalance
    const creditName = this.state.creditName
    const branchId = this.state.branchId

    let body = {
      branchId: branchId,
      totalValue: walletBalance,
      creditName: creditName,
      participants: participants.map((x) => {
        return {
          ...x,
          login: validLoginInput(x.login)
        }
      })
    }

    this.updateState('loading', true)

    const participant = getParticipantInfo()

    const headers = {
      'Authorization': `Bearer ${getAccessToken()}`,
      'campaignId': `${participant['custom:campaign_id']}`,
      'catalogId': `${participant['custom:catalog_id']}`
    }

    axios
      .post('creditRequest', body, { headers })
      .then((res) => {
        const data = res.data
        const alertMessage = `#${data.id} - ${data.creditStatus === 1 ? 'Pontos distribuidos com sucesso!' : 'Sua solicitação de pontos foi enviada para aprovação, devido à inclusão do CPF do FocalPoint no lote de distribuição'}`
        this.updateState('walletBalance', 0)
        this.updateState('alertMessage', alertMessage)
        this.navigateToList()
      })
      .catch((err) => {
        console.log(err)
        this.updateState('errorMessage', { title: 'Ocorreu um erro na distribuição de pontos!', description: '' })
      })
      .finally(() => {
        this.updateState('loading', false)
      })
  }

  navigateToList () {
    this.props.history.push({
      pathname: '/branch-details',
      state: { alertMessage: this.state.alertMessage }
    })
  }

  sortName (a, b) {
    var x = a.name.toLowerCase()
    var y = b.name.toLowerCase()
    if (x > y) return 1
    if (y > x) return -1
    return 0
  }

  toggleModal (value) {
    this.updateState('successMessage', false)
    this.updateState('errorMessage', false)
    this.updateState('disableFields', false)

    let state = this.state
    state[value] = !state[value]

    this.setState(state)
  }

  toggleCsvModal () {
    this.updateState('csvModalError', !this.state.csvModalError)
  }

  updateState = (field, value, isParticipant = false) => {
    let state = this.state

    if (isParticipant) state.participant[field] = value
    else state[field] = value

    this.setState(state)
  }

  showSuccess = (message) => {
    return message ? (
      <Alert
        isSuccess
        title={message.title}
        description={message.description}
        className='pt-2 pb-0'
        onClose={() => this.updateState('successMessage', false)}
      />
    ) : (
      ''
    )
  }

  showError = (message) => {
    return message ? (
      <Alert
        isError
        title={message.title}
        description={message.description}
        className='pt-2 pb-0'
        onClose={() => this.updateState('errorMessage', false)}
      />
    ) : (
      ''
    )
  }

  handleName = ({ target: { value } }) => {
    let name = validChangeName(value)

    let bool = true
    if (!name || !validNameInput(name)) bool = false

    this.updateState('isValidName', bool)
    this.updateState('name', name, true)
  }

  handleLogin = ({ target: { value } }) => {
    this.updateState('disableFields', false)
    this.updateState('name', '', true)
    this.updateState('email', '', true)
    this.updateState('isValidName', false)
    this.updateState('isValidEmail', false)

    let login = value

    let bool = true
    let found = this.state.participants.find((p) => p.login === login)
    if (!login || found || validLoginInput(login).length !== 11) bool = false
    else {
      this.getParticipantByLogin(validLoginInput(login))
    }

    this.updateState('isValidLogin', bool)
    this.updateState('login', login, true)
  }

  handleEmail = ({ target: { value } }) => {
    let email = value
    let bool = true

    if (!email || !validEmailInput(email)) bool = false

    this.updateState('isValidEmail', bool)
    this.updateState('email', email, true)
  }

  handlePoints = ({ target: { value } }) => {
    let points = parseFloat(validNumber(value))

    let availablebalance = this.state.availableBalance
    let bool = true
    if (!points || points > availablebalance) bool = false

    this.updateState('isValidPoints', bool)
    this.updateState('value', points, true)
  }

  handleOpenDialog = (e) => {
    console.log(typeof buttonRef)
    // Note that the ref is set async, so it might be null at some point
    if (buttonRef.current) {
      buttonRef.current.open(e)
    }
  }

  validHeader = (arr, target) => target.every(v => arr.includes(v))

  normalizeEmail = (email) => {
    let arr = email.split('.')
    let index = arr.indexOf('con')
    if (index !== -1) {
      arr[index] = 'com'
      email = arr.join('.')
    }
    return email
  }

  normalizeLogin = (login) => {
    login = login.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4')
    return login
  }

  handleOnFileLoad = (data) => {
    let header = ['name', 'login', 'email', 'value']
    let validated = this.validHeader(data[0].data, header)
    this.updateState('csvModal', false)
    if (!validated) {
      this.updateState('errorMessage', true)
      this.showError('Cabeçalho incorreto! Por favor, verifique e tente novamente.')
      return
    }
    this.updateState('participants', [])
    this.updateState('csvErrors', [])
    this.updateState('totalPoints', 0)
    let csvErrors = []
    let participants = []
    let totalValue = this.state.totalPoints
    let availableBalance = this.state.availableBalance
    let walletBalance = this.state.walletBalance

    for (let i = 1; i < data.length; i++) {
      let item = data[i]
      if (item.data[0].split(' ').length <= 1) {
        csvErrors.push({ line: i + 1, type: 'nome', value: item.data[0] })
      }
      if (this.state.loginType === 'CPF') {
        item.data[1] = (item.data[1].toString()).padStart(11, '0')
      }
      if (!this.emailCsvValidation(item.data[2])) {
        csvErrors.push({ line: i + 1, type: 'email', value: item.data[2] })
      }
      if (parseFloat(item.data[3]) < 0) {
        csvErrors.push({ line: i + 1, type: 'valor', value: data[3] })
      } else {
        totalValue += parseFloat(item.data[3])
      }
    }

    if (totalValue > availableBalance) {
      csvErrors.push({ totalPoints: totalValue })
    }

    if (csvErrors.length === 0) {
      for (let i = 1; i < data.length; i++) {
        participants.push({
          name: data[i].data[0],
          login: this.normalizeLogin(data[i].data[1]),
          email: this.normalizeEmail(data[i].data[2]),
          value: formatNumber(data[i].data[3])
        })
      }
      this.updateState('availableBalance', totalValue)
      this.updateState('participants', participants)
    } else {
      this.updateState('csvErrors', csvErrors)
      this.updateState('availableBalance', walletBalance)
    }

    this.updateState('totalPoints', totalValue)
  }

  handleOnError = (err, file, inputElem, reason) => {
    console.log(err)
  }

  handleRemoveFile = (e) => {
    if (buttonRef.current) {
      buttonRef.current.removeFile(e)
    }
  }

  render () {
    return (
      <Fragment>
        <Helmet>
          <title>{`Distribuição de Pontos Participante - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        <div className='container-fluid'>
          <div className='container'>
            <div className='row'>
              {this.showError(this.state.errorMessage)}
              {this.showSuccess(this.state.successMessage)}
              {this.state.csvErrors.length > 0 &&
                (
                  <div className='col-12 py-2'>
                    <div className='row'>
                      <div className='col-12 border-color-ui-3 bg-white border radius'>
                        <div className='row px-3 py-2 border-bottom border-color-ui-3'>
                          <h3 className='txt-initial color-brand-1 mr-auto txt-center'>
                            O CSV possui alguns erros nas informações dos participantes!
                          </h3>
                          <button
                            className='mt-2 mb-2'
                            onClick={() => { this.toggleCsvModal() }}
                          >
                            Ver erros
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              }
              <div className='col-12 py-2'>
                <div className='row'>
                  <div className='col-12 border-color-ui-3 bg-white border radius'>
                    <div className='row px-3 py-2 border-bottom border-color-ui-3 '>
                      <div className='col-8 py-1'>
                        <h3 className='txt-initial color-brand-1 mr-auto'>
                          Distribuição de Pontos Participante
                        </h3>
                      </div>
                      <div className='col-2 py-1'>
                        <button
                          onClick={() => this.updateState('csvModal', true)}
                          disabled={!this.state.branchId}
                        >
                          Importar CSV
                        </button>
                      </div>
                      <div className='col-2 py-1'>
                        <button
                          onClick={() => {
                            this.updateState('isValidName', false)
                            this.updateState('isValidLogin', false)
                            this.updateState('isValidEmail', false)
                            this.updateState('isValidPoints', false)
                            this.updateState('participantModal', true)
                          }}
                          disabled={!this.state.branchId}
                        >
                          Adicionar Participante
                        </button>
                      </div>
                      <div className='row col-12 mr-auto px-3 py-2'>
                        <div className='col-6 py-1'>
                          <h4 className='txt-initial color-brand-1 mr-auto'>
                            {formatNumber(this.state.availableBalance)} Pontos Disponíveis / Total {formatNumber(this.state.walletBalance)}
                          </h4>
                          <h4 className='txt-initial color-brand-1 mr-auto mt-1'>
                            {this.state.creditName}
                          </h4>
                        </div>
                        <div className='col-6 py-1'>
                          <h4 className='txt-initial color-brand-1 mr-auto'>
                            {this.state.branchName}
                          </h4>
                        </div>
                      </div>
                    </div>
                    {this.state.loading
                      ? (
                        <Loading
                          loading={this.state.loading}
                        />
                      )
                      : (
                        <Fragment>
                          {this.state.participants.length > 0 &&
                            (
                              <div className='col-12 order-item'>
                                <div className='mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'>
                                  <div className='order-product-info col mr-auto'>
                                    <div className='order-product-info row'>
                                      <div className='product-infos col mx-0'>
                                        <h3 className='txt-font-body txt-subtitle color-ui-2 mt-1 header-text-title col-12'>
                                          Nome Completo
                                        </h3>
                                      </div>
                                      <div className='product-infos col mx-0'>
                                        <h3 className='txt-font-body txt-subtitle color-ui-2 mt-1 header-text-title col-12'>
                                          E-mail
                                        </h3>
                                      </div>
                                      <div className='product-infos col-2 mx-0'>
                                        <h3 className='txt-font-body txt-subtitle color-ui-2 mt-1 header-text-title col-12'>
                                          CPF
                                        </h3>
                                      </div>
                                      <div className='product-infos col-2 mx-0'>
                                        <h3 className='txt-font-body txt-subtitle color-ui-2 mt-1 header-text-title col-12'>
                                          Pontos
                                        </h3>
                                      </div>
                                      <div className='product-infos col-1 mx-0'>
                                        <h3 className='txt-font-body txt-subtitle color-ui-2 mt-1 header-text-title col-12'>
                                          Ação
                                        </h3>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                          {this.state.participants.map((b, i) => {
                            return (
                              <div className='col-12 order-item'>
                                <div className='mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'>
                                  <div className='order-product-info col mr-auto'>
                                    <div className='order-product-info row'>
                                      <div className='product-infos col-12 mx-0'>
                                        <h4 className='txt-font-body txt-subtitle color-ui-2 mt-1 body-text-title'>
                                          {b.name}
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                  <div className='order-product-info col mr-auto'>
                                    <div className='order-product-info row'>
                                      <div className='product-infos col-12 mx-0'>
                                        <h4 className='txt-font-body txt-subtitle color-ui-2 mt-1 body-text-title'>
                                          {b.email}
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                  <div className='order-product-info col-2 mr-auto'>
                                    <div className='order-product-info row'>
                                      <div className='product-infos col-12 mx-0'>
                                        <h4 className='txt-font-body txt-subtitle color-ui-2 mt-1 body-text-title'>
                                          {b.login}
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                  <div className='order-product-info col-2 mr-auto'>
                                    <div className='order-product-info row'>
                                      <div className='product-infos col-12 mx-0'>
                                        <h4 className='txt-font-body txt-subtitle color-ui-2 mt-1 body-text-title'>
                                          {formatNumber(b.value)}
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                  <div className='order-action pos-relative col-1 d-none d-md-inline-block txt-center'>
                                    <div className='row align-items-center h-100 col-12'>
                                      <a
                                        onClick={() => { this.removeParticipant(i) }}
                                        href='javascript:void(0)'
                                        role='button'
                                        aria-label='Excluir participante'
                                        className='d-inline-block ml-1'
                                      >
                                        <Icon
                                          iconName='icon_trash'
                                          className='position-relative pos-relative l-0 t-0'
                                        />
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          })}
                          {this.state.participants.length > 0 &&
                            (
                              <div className='order-product-info col-12 mr-auto'>
                                <div className='order-product-info row'>
                                  <div className='product-infos col-12 mt-2 mb-2'>
                                    <button
                                      onClick={() => this.sendPoints()}
                                      disabled={!this.correctlyPoints()}
                                    >
                                      Distribuir Pontos
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                        </Fragment>
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
            { /* eslint-disable react/jsx-no-bind */}
            <ParticipantModal
              modal={this.state.participantModal}
              isValidPoints={this.state.isValidPoints}
              isValidName={this.state.isValidName}
              isValidEmail={this.state.isValidEmail}
              isValidLogin={this.state.isValidLogin}
              disableFields={this.state.disableFields}
              participant={this.state.participant}
              handleName={this.handleName.bind(this)}
              handleLogin={this.handleLogin.bind(this)}
              handleEmail={this.handleEmail.bind(this)}
              handlePoints={this.handlePoints.bind(this)}
              toggleModal={this.toggleModal.bind(this)}
              submit={this.addParticipant.bind(this)}
            />
            <CsvModalError
              modal={this.state.csvModalError}
              csvError={this.state.csvErrors}
              totalPoints={this.state.totalPoints}
              walletBalance={this.state.walletBalance}
              toggleModal={this.toggleModal.bind(this)}
            />
            <CsvModal
              modal={this.state.csvModal}
              participant={this.state.participant}
              toggleModal={this.toggleModal.bind(this)}
              updateState={this.updateState.bind(this)}
              submit={this.addParticipant.bind(this)}
              downloadModelo={this.downloadModelo.bind(this)}
              uploadCallback={this.uploadCallback.bind(this)}
              handleOnFileLoad={this.handleOnFileLoad.bind(this)}
              handleOnError={this.handleOnError.bind(this)}
              handleOpenDialog={this.handleOpenDialog.bind(this)}
              buttonRef={buttonRef}
            />
            { /* eslint-enable react/jsx-no-bind */}
          </div>
        </div>
      </Fragment>
    )
  }
}

ParticipantDistributionPoint.propTypes = {
  history: PropTypes.object
}

export default ParticipantDistributionPoint



// WEBPACK FOOTER //
// ./src/features/FocalPoint/Participant/ParticipantDistributionPoint.js